/* global _ */
import Tool from '../../script/tool.js'
export function lineChartOptionFactory ({
  legendData = [],
  xAxisData = [],
  seriesItems = [],
  extendXAxis = [],
  yAxis = []
}) {
  const defaultYAxis = [
    {
      type: 'value',
      splitLine: {
        lineStyle: {
          color: ['#DADFE6']
        }
      }
    }
  ]
  const seriesData = seriesItems.map((item, index) =>
    lineSeriesItemFactory(index, item)
  )
  /* eslint-disable no-param-reassign */
  yAxis = yAxis.length === 0 ? defaultYAxis : yAxis
  const opt = {
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        const legendNames = _.uniq(_.map(params, 'name')) // 由数据的 name 属性获取图例数据
        let str = `${legendNames}</br>`

        str += params.reduce((result, item, index) => {
          const { value = '-', color, seriesName } = item
          let formatvalue = value
          if (seriesName.includes('平均访问时长')) {
            formatvalue = Tool.timeFormate(value)
          }
          if (index !== 0) {
            result += '</br>'
          }
          result += `<span style="display:inline-block;margin-right:5px;
            border-radius:10px;width:9px;height:9px;
            background: ${color}"></span>${seriesName} : ${formatvalue}`
          return result
        }, '')
        return str
      }
    },
    legend: {
      right: '20',
      bottom: '5',
      data: legendData,
      formatter: name => {
        return name.length > 60 ? `${name.slice(0, 60)}...` : name
      },
      tooltip: {
        show: true
      }
    },
    grid: {
      top: '6%',
      left: '3%',
      right: '4%',
      bottom: '15%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: false,
        data: xAxisData
      }
    ],
    yAxis: yAxis,
    series: seriesData
  }

  return opt
}

const LINECOLORS = [
  ['#e56d45', 'rgba(229, 109, 69, 0.2)'],
  ['#4CA63A', 'rgba(76, 166, 58, 0.2)'],
  ['#2d70b3', 'rgba(45, 112, 179, 0.2)'],
  ['#6b47b3', 'rgba(107, 71, 179, 0.2)'],
  ['#ff524f', 'rgba(255, 82, 79, 0.2)']
]

function lineSeriesItemFactory (i, { name, data, yAxisIndex = 0 }) {
  return {
    type: 'line',
    symbolSize: 5,
    symbol: 'emptyCircle',
    smooth: true,
    itemStyle: { normal: { color: LINECOLORS[i][0] } },
    areaStyle: { normal: { color: LINECOLORS[i][1] } },
    yAxisIndex: yAxisIndex,
    name: name,
    data: data
  }
}

export const PIE_COLORS = [
  '#56BF8B',
  '#73ACE6',
  '#BF86B6',
  '#E5B82E',
  '#E5675C',
  '#66C3CC',
  '#A3B3BF',
  '#6390A6',
  '#e96b3a',
  '#276ab0',
  '#F2C230'
  // 下面是规范上的颜色
  /* '#56BF8B',
    '#73ACE6',
    '#BF86B6',
    '#F2C230',
    '#E5675C',
    '#66C3CC',
    '#ABBCCC',
    '#6390A6' */
]

export function pieChartOptionFactory ({
  fromAttr,
  comp,
  color = PIE_COLORS,
  legendData,
  seriesItems,
  customOptions = {}
}) {
  const { tooltipFormatter, labelFormatter } = customOptions
  const seriesData = pieSeriesFactory(seriesItems, labelFormatter, comp)
  const result1 = _.merge(
    {
      color: color,
      tooltip: {
        formatter: tooltipFormatter || '{b}: {c}',
        show: true
      },
      legend: {
        right: 5,
        bottom: 5,
        orient: 'vertical', // seriesData[0].data.length > 2 ? 'vertical' : 'horizontal',
        data: legendData,
        itemWidth: 15,
        itemHeight: 10,
        itemGap: 3
        // selectedMode: false
      },
      series: seriesData
    },
    customOptions
  )

  const result2 = _.merge(
    {
      tooltip: {
        formatter: tooltipFormatter || '{b}: {c}',
        show: true
      },
      color: ['#e5675c', '#6390a6'],
      legend: {
        top: 15,
        left: 15,
        orient: 'horizontal', // seriesData[0].data.length > 2 ? 'vertical' : 'horizontal',
        data: legendData,
        itemWidth: 12,
        itemHeight: 12,
        itemGap: 15
        // selectedMode: false
      },
      series: seriesData
    },
    customOptions
  )

  return fromAttr ? result2 : result1
}

// DOC http://echarts.baidu.com/option.html#series-pie.hoverAnimation
function getPieSeriesList (data, labelFormatter) {
  return [
    {
      type: 'pie',
      voidLabelOverlap: true,
      // stillShowZeroSum: false,
      radius: ['35%', '55%'],
      hoverAnimation: 0,
      clockwise: true,
      label: {
        normal: {
          show: true
        },
        emphasis: {
          show: true,
          textStyle: {
            fontWeight: 'bold'
          }
        }
      },
      labelline: {
        normal: {
          show: true
        }
      },
      data: _.has(data, 'data') ? data.data : data
    }
  ]
}
function pieSeriesFactory (data, labelFormatter, comp) {
  const colors = [['#e5675c', '#6390a6'], ['#f2c230', '#66c3cc']]
  if (!comp) {
    return getPieSeriesList(data)
  }
  return data.reduce((result, item, index) => {
    const series = getPieSeriesList(item)
    series[0].name = item.name
    series[0].radius = [`${50 - index * 15}%`, `${60 - index * 15}%`]
    series[0].color = colors[index]
    if (index === 1) {
      series[0].startAngle = 135
    }
    result.push(series[0])
    return result
  }, [])
}

const ceil = n => {
  const len = String(n).length
  const exp = 10 ** (len - 1)
  return exp * Math.ceil(n / exp)
}
const floor = n => {
  const len = String(n).length
  const exp = 10 ** (len - 1)
  return exp * Math.floor(n / exp)
}

export function mapChartOptionFactory ({ seriesItems, seriesName }) {
  const values = seriesItems.map(item => item.value)
  const min = Math.min(...values)
  const max = Math.max(...values)

  return {
    tooltip: { trigger: 'item' },
    visualMap: {
      splitNumber: 5,
      min: floor(min),
      max: ceil(max),
      text: ['高', '低'],
      inRange: {
        color: ['#f0ffff', '#4fc188']
      },
      right: 5,
      bottom: 5,
      itemGap: 3,
      itemHeight: 10,
      padding: 0
    },
    series: [
      {
        name: seriesName || '',
        type: 'map',
        mapType: 'china',
        roam: false,
        label: {
          normal: { show: false },
          emphasis: { show: true }
        },
        itemStyle: {
          normal: {
            borderColor: 'transparent'
          },
          emphasis: {
            color: '#EDCD34',
            label: {
              show: true
            }
          }
        },
        data: seriesItems
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/component/charts/options.js